import { request } from './http';
import { config } from './config';
import type { LatLon, RegionData } from '../domain/types';

type RegionEnvelope = {
  country?: {
    country_code?: string;
    currency_code?: string;
    language_code?: string;
    city_id?: string;
    cityId?: string;
    district_id?: string | null;
    h3_code?: string | null;
  };
};

// POST {rpcBaseUrl}/get-points-country-data — same endpoint Flutter calls before
// building a route/order. It gives the authoritative cityId/district/h3 for the
// pickup point, which is required by Order.API tariff lookup.
export async function getPointRegion(point: LatLon): Promise<RegionData> {
  const res = await request<RegionEnvelope>('/get-points-country-data', {
    method: 'POST',
    baseUrl: config.rpcBaseUrl,
    auth: false,
    body: {
      point: `${point.lat} ${point.lon}`,
      is_authentication: false,
    },
  });

  const country = res.country ?? {};
  return {
    countryCode: country.country_code ?? config.defaultCountry,
    currencyCode: country.currency_code ?? config.defaultCurrency,
    languageCode: country.language_code ?? config.defaultLanguage.toUpperCase(),
    cityId: country.city_id ?? country.cityId ?? '',
    districtId: country.district_id ?? null,
    h3Code: country.h3_code ?? null,
  };
}
